import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import $ from 'jquery';

import App from './components/App';

window.jQuery = $;

if ('undefined' !== typeof window.social_link_pages) {
	const rootElement = document.getElementById('social_link_pages-root');
	rootElement.classList.add('social_link_pages-root');
	ReactDOM.render(
		<Router>
			<App />
		</Router>,
		rootElement,
	);
}
